import { USER_ROLE } from 'models/User'
import ROUTES from 'routing/adminRoutes'
import { AsyncHome } from 'ui/pages'
import AdminRouteLayout from '../../../Admin/AdminRouteLayout'
import AdminRoute from '../../AdminRoute'

const homeRoutes = [
  <AdminRoute
    exact
    path={ROUTES.HOME}
    layout={AdminRouteLayout}
    component={AsyncHome}
    allowedRoles={[
      USER_ROLE.ACCOUNT_MANAGER_LEVEL_1,
      USER_ROLE.ACCOUNT_MANAGER_LEVEL_2,
      USER_ROLE.ADMIN,
    ]}
    redirectTo={ROUTES.SHIFTS}
    key={ROUTES.HOME}
  />,
]

export default homeRoutes
